/**
 * @generated SignedSource<<234c3f0bc2e7be4d2dd8e397f58dc4a7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Header$data = {
  readonly author: {
    readonly login: string;
  } | null;
  readonly createdAt: string;
  readonly id: string;
  readonly isTransferInProgress: boolean;
  readonly issueType: {
    readonly id: string;
    readonly name: string;
  } | null;
  readonly repository: {
    readonly id: string;
    readonly isPrivate: boolean;
    readonly name: string;
    readonly owner: {
      readonly __typename: string;
      readonly avatarUrl: string;
      readonly login: string;
    };
  };
  readonly tasklistBlocksCompletion: {
    readonly " $fragmentSpreads": FragmentRefs<"TaskListStatus">;
  } | null;
  readonly url: string;
  readonly " $fragmentSpreads": FragmentRefs<"HeaderIssueTitle" | "HeaderMenu" | "HeaderState" | "HeaderViewer" | "RepositoryPill" | "StickyHeaderTitle">;
  readonly " $fragmentType": "Header";
};
export type Header$key = {
  readonly " $data"?: Header$data;
  readonly " $fragmentSpreads": FragmentRefs<"Header">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "login",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Header",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "author",
      "plural": false,
      "selections": [
        (v1/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isTransferInProgress",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Repository",
      "kind": "LinkedField",
      "name": "repository",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isPrivate",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "owner",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__typename",
              "storageKey": null
            },
            {
              "alias": null,
              "args": [
                {
                  "kind": "Literal",
                  "name": "size",
                  "value": 64
                }
              ],
              "kind": "ScalarField",
              "name": "avatarUrl",
              "storageKey": "avatarUrl(size:64)"
            },
            (v1/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HeaderState"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HeaderIssueTitle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "StickyHeaderTitle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HeaderMenu"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HeaderViewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RepositoryPill"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TrackedIssueCompletion",
      "kind": "LinkedField",
      "name": "tasklistBlocksCompletion",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TaskListStatus"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "IssueType",
      "kind": "LinkedField",
      "name": "issueType",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v2/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "Issue",
  "abstractKey": null
};
})();

(node as any).hash = "c949a5a542eb83e4ca621e40a492c746";

export default node;
